module.exports = __webpack_public_path__ + "img/2871d29.jpg";